import { Box, BoxProps } from '@razorpay/blade/components';

export const StepActionsWrapper = ({ children, ...boxProps }: BoxProps) => (
  <Box
    display="flex"
    width="100%"
    position="sticky"
    zIndex="2"
    bottom={'0px'}
    left={'0px'}
    borderTopWidth="thin"
    borderColor="surface.border.gray.subtle"
    borderStyle="solid"
    backgroundColor="surface.background.gray.intense">
    <Box
      maxWidth="700px"
      width={{ base: '100%', m: '700px' }}
      marginX="auto"
      paddingX={{ base: 'spacing.7', m: 'spacing.0' }}
      paddingTop="spacing.5"
      paddingBottom="spacing.7"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      {...boxProps}>
      {children}
    </Box>
  </Box>
);
